import { defaultUrlTransform } from 'react-markdown';

export const getMapDescriptionLinkType = (url: string): 'internal_map' | 'external' | 'other' => {
    if (/^(?:wemod|wand):\/\//i.test(url)) return 'internal_map';
    if (/^https?:\/\//i.test(url)) return 'external';
    return 'other';
};

export const transformMapDescriptionUrl = (url: string) => {
    if (url.startsWith('wemod://') || url.startsWith('wand://')) {
        return url;
    }

    return defaultUrlTransform(/^www\./i.test(url) ? `https://${url}` : url);
};
